<template lang="pug">
section.LndProducts
  h2(v-html="L.header")

  ul.d-flex.--spread.__list(:class="mq.sm && '--wrap'")
    a(v-for="item of L.list", :href="item.url", target="_blank", :class="`--${ item.name }`")
      h3 {{ item.name }}
      img.__logo(:src="item.logo", :alt="item.name")
      .__name(v-html="item.name")
      ul.__desc(v-if="Array.isArray(item.desc)")
        li(v-for="desc of item.desc", v-html="desc")
      span.__desc(v-else, v-html="item.desc")
</template>
<script>
import content from 'content';

export default {
  name: 'LndProducts',

  inject: ['mq'],
  static: () => ({
    L: content.products,
  }),
};

</script>
<style>
.LndProducts {
  --list-pad: 35px;

  h2 {
    margin-bottom: 40px;
  }

  .__logo {
    align-self: baseline;
    height: 32px;
    margin-bottom: 38px;

    filter: invert(1);
  }

  .__list {
    --gap-h: 20px;
    --gap-v: 20px;

    > a {
      display: flex;
      flex-basis: 200px;
      flex-direction: column;
      flex-grow: 2;
      flex-shrink: 20;
      justify-content: space-between;
      min-height: 50vh;
      padding: var(--list-pad);

      background: rgba(0, 0, 0, .1);
      /*border: 1px solid var(--border-c);*/

      transition: background .2s;

      &:hover {
        background: var(--bg-c);
      }

      &.--influmtr .__logo { height: 21px; }
    }

    h3 { display: none; }
  }

  .__name {
    display: none;
    margin-bottom: 38px;

    font-weight: 500;
    font-size: 20px;
    line-height: 35px;
    text-transform: capitalize;

    &:after {
      float: right;
      color: var(--accent-c);

      content: '→';
    }
  }

  .__desc {
    font-size: 14px;
    line-height: 35px;

  }

  ul.__desc {
    li { position: relative; }

    li::before {
      --w: 8px;
      position: absolute;
      top: 17px;
      left: calc(var(--list-pad) / -2 - var(--w) / 2);

      display: block;
      width: var(--w);
      height: 2px;

      background: var(--text-c);

      content: '';
    }
  }
}

@media (max-width: 739px) {
  .LndProducts {
    .__list {
      > a {
        min-height: auto;

        background: var(--bg-c);

        .__name {
          margin-bottom: 100px;
        }
      }
    }
  }
}
</style>
